import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c98aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white pt-12 p-5 space-y-4" }
const _hoisted_2 = { class: "font-semibold text-lg text-center break-words truncate" }
const _hoisted_3 = { class: "space-y-4 border-b pb-8 -mx-5 px-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "what py-4" }, "What are Information NFTs and Tokens?", -1))

import { Icon } from '@iconify/vue';
import NavItem from '@/components/NavItem.vue';
import { useUserStore } from '@/store/user';
import useCopyToClipboard from '@/composables/useCopyToClipboard';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const { copyToClipboard } = useCopyToClipboard();

return (_ctx: any,_cache: any) => {
  const _component_BaseMasked = _resolveComponent("BaseMasked")!
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBox, { class: "mb-16" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(userStore).email), 1),
        _createElementVNode("div", {
          class: "flex items-center justify-center space-x-2 mt-3 cursor-pointer",
          style: {"color":"#676767"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copyToClipboard)(_unref(userStore).ethAddress)))
        }, [
          _createVNode(_component_BaseMasked, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(userStore).ethAddress), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Icon), { icon: "ci:copy" })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(NavItem, {
        to: "/app/inventory",
        title: "Your contribution"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            class: "icon",
            icon: "uil:user-square"
          })
        ]),
        _: 1
      }),
      _createVNode(NavItem, {
        to: "/app/activity",
        title: "History"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            class: "icon",
            icon: "bx:bx-time"
          })
        ]),
        _: 1
      }),
      _createVNode(NavItem, {
        to: "/app/receive-nft",
        title: "Receive NFTs"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            class: "icon",
            icon: "material-symbols:generating-tokens-outline"
          })
        ]),
        _: 1
      }),
      _createVNode(NavItem, {
        to: "/app/claim",
        title: "Receive tokens"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            class: "icon",
            icon: "fluent:ribbon-32-regular"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_link, { to: "/landing/information-nfts" }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}
}

})